// addAppPhonePane.js — /add-app on a phone: ONE pane at a time (persona round
// 5, marcus, iPhone 390, shots 021/034: "the screen was a pile — an apps list,
// a small chat box, three rows of buttons, then the preview").
//
// Where the builder is narrow (`@mobileL`, or an `@appMobile` pane) it shows
// one of three panes: the chat (the default), the preview of the app, or the
// person's apps list. The choice is `root._addAppPhonePane`; the page
// publishes the pane it shows as `data-phone-pane` and its narrow media rules
// hide the other two (pages/add-app.js). The wide layout ignores it: the apps
// rail there is a page sidebar (shared functions/pageSidebar.js, Nika
// 2026-10-29 "Same rule for all") — shown unless the person hid it for the
// page, with its own hide button and reopen tab. The apps pane is only ever
// the person's own choice: nothing opens it by itself.
//
// Moves: Preview (the chat head) → the preview; Back to build (the preview's
// actions) → the chat; the apps toggle → the apps list, and back; a pick in
// the apps list → that app's preview; a build that lands → its preview.
//
// FRANK: every export is self-contained (FA204) and a `function` (`el.call`
// passes the element as `this`).

// The pane a narrow builder shows. The preview only once there is something
// to show there (a render, or the switch skeleton); otherwise the chat.
// → 'chat' | 'preview' | 'apps'
export function addAppPhonePane(root) {
  const r = root && typeof root === 'object' ? root : {}
  const want = r._addAppPhonePane
  if (want === 'apps') return 'apps'
  if (want === 'preview' && (r._addAppRendered || r._addAppSwitching)) return 'preview'
  return 'chat'
}

// Show one pane (an unknown name is the chat). The apps pane shows the list
// even where the person hid the rail for the page (a narrow app surface off a
// phone keeps that choice, and the pane would be empty): it shows the rail
// again, the way the wide layout's reopen tab does.
export function addAppPhonePaneSet(pane) {
  const root = this && this.state && this.state.root
  if (!root || typeof root.update !== 'function') return null
  const next = pane === 'apps' || pane === 'preview' ? pane : 'chat'
  root.update({ _addAppPhonePane: next }, { preventFetch: true })
  if (next === 'apps' && typeof this.call === 'function') {
    const now = this.call('pageSidebarRead', root, this)
    if (now && now.hidden === true) this.call('pageSidebarSet', now.key, false)
  }
  return next
}

// The chat head's apps button (drawn on the narrow flow only). `shown` = the
// apps list is on screen now (the caller reads its own layout: narrow, it is
// the pane). On screen → back to the chat (a pane move, never the rail's
// hide); else → the apps pane, the rail shown again as above.
export function addAppAppsToggle(shown) {
  const root = this && this.state && this.state.root
  if (!root || typeof root.update !== 'function') return null
  const next = shown ? 'chat' : 'apps'
  root.update({ _addAppPhonePane: next }, { preventFetch: true })
  if (next === 'apps' && typeof this.call === 'function') {
    const now = this.call('pageSidebarRead', root, this)
    if (now && now.hidden === true) this.call('pageSidebarSet', now.key, false)
  }
  return !shown
}
